module.exports = __webpack_public_path__ + "static/img/solution2.adde8d3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/solution2.jpg
// module id = sUm/
// module chunks = 9